"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var container_1 = require("./lib/container");
exports.Container = container_1.Container;
var helpers_1 = require("./lib/helpers");
exports.Inject = helpers_1.Inject;
exports.inject = helpers_1.inject;
exports.injectable = helpers_1.injectable;
exports.mockInject = helpers_1.mockInject;
exports.mockRequest = helpers_1.mockRequest;
exports.mockSingleton = helpers_1.mockSingleton;
exports.mockTransient = helpers_1.mockTransient;
exports.resetContainer = helpers_1.resetContainer;
// How to inject a dependency
// @Inject() nameService: INameService;
exports.container = new container_1.Container({ skipBaseClassChecks: true });
var cid = helpers_1.DependencyId;
exports.cid = cid;
//# sourceMappingURL=index.js.map